var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_4096216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 13.14,
    rx: 3.46,
    width: 13.14,
    x: 16.86,
    y: 16.86
  }), /*#__PURE__*/React.createElement("rect", {
    height: 13.14,
    rx: 3.46,
    width: 13.14,
    x: 2,
    y: 16.86
  }), /*#__PURE__*/React.createElement("rect", {
    height: 13.14,
    rx: 3.46,
    width: 13.14,
    x: 16.86,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 13.14,
    rx: 3.46,
    width: 13.14,
    x: 2,
    y: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu-close.449d943a004bc3360a477589512b47df.svg";
export { ForwardRef as ReactComponent };